import { useRef, useState } from "react";
import { Check, MoreVertical, RefreshCw } from "lucide-react";
import { useClickOutside } from "../../hooks";
import { BrianToggleButton } from "../Brian";

type DashboardToolbarProps = {
  onRefresh: () => void;
  onOpenChangelog: () => void;
  onManageReports: () => void;
  isShared?: boolean;
  onShareToggle?: () => void;
  onBrianOpen: () => void;
  brianOpen?: boolean;
};

export default function DashboardToolbar({
  onRefresh,
  onOpenChangelog,
  onManageReports,
  isShared = false,
  onShareToggle,
  onBrianOpen,
  brianOpen = false,
}: DashboardToolbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useClickOutside(menuRef, () => setMenuOpen(false), menuOpen);

  return (
    <div className="mb-5 flex items-center justify-end">
      <div className="flex items-center gap-3">
        <button
          onClick={onRefresh}
          className="flex items-center gap-1.5 rounded-lg border border-gray-200 px-3 py-1.5 text-xs font-medium text-gray-600 hover:border-gray-300 hover:text-gray-800"
        >
          <RefreshCw size={12} />
          Refresh all
        </button>
        <BrianToggleButton open={brianOpen} onToggle={onBrianOpen} size="sm" />
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen((o) => !o)}
            title="More"
            className="flex items-center rounded-lg border border-gray-200 p-1.5 text-gray-500 hover:border-gray-300 hover:text-gray-800"
          >
            <MoreVertical size={14} />
          </button>
          {menuOpen && (
            <div className="absolute right-0 top-full z-10 mt-1 w-44 rounded-lg border border-gray-200 bg-white py-1 shadow-md">
              <button
                onClick={() => { setMenuOpen(false); onOpenChangelog(); }}
                className="flex w-full items-center px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50"
              >
                Changelog
              </button>
              <button
                onClick={() => { setMenuOpen(false); onManageReports(); }}
                className="flex w-full items-center px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50"
              >
                Manage reports
              </button>
              {onShareToggle && (
                <button
                  onClick={() => { setMenuOpen(false); onShareToggle(); }}
                  className="flex w-full items-center justify-between px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50"
                >
                  Share to library
                  {isShared && <Check size={12} className="text-green-600" />}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
